import { Gallery } from '../components/Gallery';
import { useGalleryService } from '../services/useGalleryService';

export interface GalleryContainerProps {
  className?: string;
}

export const GalleryContainer: React.FC<React.PropsWithChildren<GalleryContainerProps>> = ({ className, children }) => {
  const {
    handleChangeIndex,
    image_list,
    current_index,
    is_button_hidden,
    is_dots_hidden,
    is_fit_contain,
    first_image_height_ratio,
  } = useGalleryService();

  return (
    <Gallery
      className={className}
      onChangeIndex={handleChangeIndex}
      image_list={image_list}
      is_button_hidden={is_button_hidden}
      is_dots_hidden={is_dots_hidden}
      current_index={current_index}
      is_fit_contain={is_fit_contain}
      height_ratio={first_image_height_ratio}
      children={children}
    />
  );
};
